/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import loadable from '@loadable/component';

import Banner from '../components/CityConnect/Banner';
import DashboardTabs from '../components/CityConnect/DashboardTabs';
import PageHeaderWithLogin from '../components/CityConnect/PageHeaderWithLogin';
import PageHeaderWithLoginIframe from '../components/CityConnect/PageHeaderWithLoginIframe';
import PaymentDueMutiplePay from '../components/CityConnect/PaymentDueMutiplePay';
import PaymentHistory from '../components/CityConnect/PaymentHistory';
import PaymentsDueCard from '../components/CityConnect/PaymentsDueCard';
import PaymentsDueList from '../components/CityConnect/PaymentsDueList';
import PersonalInfo from '../components/CityConnect/PersonalInfo';
import PropertyRates from '../components/CityConnect/PropertyRates';
import QuickLinks from '../components/CityConnect/QuickLinks';
import RatesCalculator from '../components/CityConnect/RatesCalculator';
import RatesNoticeDeliveryCard from '../components/CityConnect/RatesNoticeDeliveryCard';
import RatesPaymentArrangement from '../components/CityConnect/RatesPaymentArrangement';
import RatesSummaryCard from '../components/CityConnect/RatesSummaryCard';
import Registration from '../components/CityConnect/Registration';
import RequestTracker from '../components/CityConnect/RequestTracker';
import ScheduledPayments from '../components/CityConnect/ScheduledPayments';
import ServiceAnnouncement from '../components/CityConnect/ServiceAnnouncement';
import ShowMore from '../components/CityConnect/ShowMore';
import SingleColumnCurvedBorder from '../components/CityConnect/SingleColumnCurvedBorder';
import TextMessage from '../components/CityConnect/TextMessage';
import Tiles from '../components/CityConnect/Tiles';
import TwoColumnsCurvedBorder from '../components/CityConnect/TwoColumnsCurvedBorder';
import UserProfileDropdown from '../components/CityConnect/UserProfileDropdown';
import UserProfileDropdownIframe from '../components/CityConnect/UserProfileDropdownIframe';
import CommunityEngagementProfile from '../components/CommunityEngagement/CommunityEngagementProfile';
import CalloutMessageBox from '../components/Corporate/CalloutMessageBox';
import EmbedJotform from '../components/Corporate/EmbedJotform';
import EmbedWidget from '../components/Corporate/EmbedWidget';
import HomepageBanner from '../components/Corporate/HomepageBanner';
import InternalLink from '../components/Corporate/InternalLink';
import LinkButtons from '../components/Corporate/LinkButtons';
import MainMenu from '../components/Corporate/MainMenu';
import MainSearch from '../components/Corporate/MainSearch';
import MenuButton from '../components/Corporate/MenuButton';
import Metadata from '../components/Corporate/Metadata';
import Modal from '../components/Corporate/Modal';
import NavItem from '../components/Corporate/NavItem';
import PageBanner from '../components/Corporate/PageBanner';
import PageFooter from '../components/Corporate/PageFooter';
import PageHeader from '../components/Corporate/PageHeader';
import QuickClose from '../components/Corporate/QuickClose';
import RelatedContentMap from '../components/Corporate/RelatedContentMap';
import SingleColumn from '../components/Corporate/SingleColumn';
import Timeline from '../components/Corporate/Timeline';
import TwoColumn from '../components/Corporate/TwoColumn';

const components = new Map();

  // standard component Banner
  components.set('Banner', Banner);

  // standard component DashboardTabs
  components.set('DashboardTabs', DashboardTabs);

  // standard component PageHeaderWithLogin
  components.set('PageHeaderWithLogin', PageHeaderWithLogin);

  // standard component PageHeaderWithLoginIframe
  components.set('PageHeaderWithLoginIframe', PageHeaderWithLoginIframe);

  // standard component PaymentDueMutiplePay
  components.set('PaymentDueMutiplePay', PaymentDueMutiplePay);

  // standard component PaymentHistory
  components.set('PaymentHistory', PaymentHistory);

  // standard component PaymentsDueCard
  components.set('PaymentsDueCard', PaymentsDueCard);

  // standard component PaymentsDueList
  components.set('PaymentsDueList', PaymentsDueList);

  // standard component PersonalInfo
  components.set('PersonalInfo', PersonalInfo);

  // standard component PropertyRates
  components.set('PropertyRates', PropertyRates);

  // standard component QuickLinks
  components.set('QuickLinks', QuickLinks);

  // standard component RatesCalculator
  components.set('RatesCalculator', RatesCalculator);

  // standard component RatesNoticeDeliveryCard
  components.set('RatesNoticeDeliveryCard', RatesNoticeDeliveryCard);

  // standard component RatesPaymentArrangement
  components.set('RatesPaymentArrangement', RatesPaymentArrangement);

  // standard component RatesSummaryCard
  components.set('RatesSummaryCard', RatesSummaryCard);

  // standard component Registration
  components.set('Registration', Registration);

  // standard component RequestTracker
  components.set('RequestTracker', RequestTracker);

  // standard component ScheduledPayments
  components.set('ScheduledPayments', ScheduledPayments);

  // standard component ServiceAnnouncement
  components.set('ServiceAnnouncement', ServiceAnnouncement);

  // standard component ShowMore
  components.set('ShowMore', ShowMore);

  // standard component SingleColumnCurvedBorder
  components.set('SingleColumnCurvedBorder', SingleColumnCurvedBorder);

  // standard component TextMessage
  components.set('TextMessage', TextMessage);

  // standard component Tiles
  components.set('Tiles', Tiles);

  // standard component TwoColumnsCurvedBorder
  components.set('TwoColumnsCurvedBorder', TwoColumnsCurvedBorder);

  // standard component UserProfileDropdown
  components.set('UserProfileDropdown', UserProfileDropdown);

  // standard component UserProfileDropdownIframe
  components.set('UserProfileDropdownIframe', UserProfileDropdownIframe);

  // standard component CommunityEngagementProfile
  components.set('CommunityEngagementProfile', CommunityEngagementProfile);

  // dynamic component Accordion
  components.set('Accordion', loadable(() => import(/* webpackChunkName: "Accordion" */'../components/Corporate/Accordion')))

  // dynamic component AddressCard
  components.set('AddressCard', loadable(() => import(/* webpackChunkName: "AddressCard" */'../components/Corporate/AddressCard')))

  // dynamic component Announcements
  components.set('Announcements', loadable(() => import(/* webpackChunkName: "Announcements" */'../components/Corporate/Announcements')))

  // dynamic component Callout
  components.set('Callout', loadable(() => import(/* webpackChunkName: "Callout" */'../components/Corporate/Callout')))

  // standard component CalloutMessageBox
  components.set('CalloutMessageBox', CalloutMessageBox);

  // dynamic component CallToAction
  components.set('CallToAction', loadable(() => import(/* webpackChunkName: "CallToAction" */'../components/Corporate/CallToAction')))

  // dynamic component ContentRichText
  components.set('ContentRichText', loadable(() => import(/* webpackChunkName: "ContentRichText" */'../components/Corporate/ContentRichText')))

  // dynamic component CostAndFees
  components.set('CostAndFees', loadable(() => import(/* webpackChunkName: "CostAndFees" */'../components/Corporate/CostAndFees')))

  // dynamic component DaysAndTimes
  components.set('DaysAndTimes', loadable(() => import(/* webpackChunkName: "DaysAndTimes" */'../components/Corporate/DaysAndTimes')))

  // dynamic component DetailWithIconList
  components.set('DetailWithIconList', loadable(() => import(/* webpackChunkName: "DetailWithIconList" */'../components/Corporate/DetailWithIconList')))

  // dynamic component Divider
  components.set('Divider', loadable(() => import(/* webpackChunkName: "Divider" */'../components/Corporate/Divider')))

  // dynamic component DownloadableFile
  components.set('DownloadableFile', loadable(() => import(/* webpackChunkName: "DownloadableFile" */'../components/Corporate/DownloadableFile')))

  // dynamic component DownloadableFiles
  components.set('DownloadableFiles', loadable(() => import(/* webpackChunkName: "DownloadableFiles" */'../components/Corporate/DownloadableFiles')))

  // standard component EmbedJotform
  components.set('EmbedJotform', EmbedJotform);

  // dynamic component EmbedlyCard
  components.set('EmbedlyCard', loadable(() => import(/* webpackChunkName: "EmbedlyCard" */'../components/Corporate/EmbedlyCard')))

  // standard component EmbedWidget
  components.set('EmbedWidget', EmbedWidget);

  // dynamic component FeaturedContent
  components.set('FeaturedContent', loadable(() => import(/* webpackChunkName: "FeaturedContent" */'../components/Corporate/FeaturedContent')))

  // dynamic component FeatureList
  components.set('FeatureList', loadable(() => import(/* webpackChunkName: "FeatureList" */'../components/Corporate/FeatureList')))

  // dynamic component Gallery
  components.set('Gallery', loadable(() => import(/* webpackChunkName: "Gallery" */'../components/Corporate/Gallery')))

  // dynamic component GetDirectionsLink
  components.set('GetDirectionsLink', loadable(() => import(/* webpackChunkName: "GetDirectionsLink" */'../components/Corporate/GetDirectionsLink')))

  // dynamic component GroupedContentList
  components.set('GroupedContentList', loadable(() => import(/* webpackChunkName: "GroupedContentList" */'../components/Corporate/GroupedContentList')))

  // standard component HomepageBanner
  components.set('HomepageBanner', HomepageBanner);

  // standard component InternalLink
  components.set('InternalLink', InternalLink);

  // standard component LinkButtons
  components.set('LinkButtons', LinkButtons);

  // standard component MainMenu
  components.set('MainMenu', MainMenu);

  // standard component MainSearch
  components.set('MainSearch', MainSearch);

  // dynamic component MapStatic
  components.set('MapStatic', loadable(() => import(/* webpackChunkName: "MapStatic" */'../components/Corporate/MapStatic')))

  // standard component MenuButton
  components.set('MenuButton', MenuButton);

  // standard component Metadata
  components.set('Metadata', Metadata);

  // standard component Modal
  components.set('Modal', Modal);

  // standard component NavItem
  components.set('NavItem', NavItem);

  // dynamic component NewsRelatedContent
  components.set('NewsRelatedContent', loadable(() => import(/* webpackChunkName: "NewsRelatedContent" */'../components/Corporate/NewsRelatedContent')))

  // standard component PageBanner
  components.set('PageBanner', PageBanner);

  // dynamic component PageFeedback
  components.set('PageFeedback', loadable(() => import(/* webpackChunkName: "PageFeedback" */'../components/Corporate/PageFeedback')))

  // standard component PageFooter
  components.set('PageFooter', PageFooter);

  // standard component PageHeader
  components.set('PageHeader', PageHeader);

  // dynamic component PageIntro
  components.set('PageIntro', loadable(() => import(/* webpackChunkName: "PageIntro" */'../components/Corporate/PageIntro')))

  // dynamic component Pagination
  components.set('Pagination', loadable(() => import(/* webpackChunkName: "Pagination" */'../components/Corporate/Pagination')))

  // dynamic component Profiles
  components.set('Profiles', loadable(() => import(/* webpackChunkName: "Profiles" */'../components/Corporate/Profiles')))

  // standard component QuickClose
  components.set('QuickClose', QuickClose);

  // dynamic component RelatedContentCarousel
  components.set('RelatedContentCarousel', loadable(() => import(/* webpackChunkName: "RelatedContentCarousel" */'../components/Corporate/RelatedContentCarousel')))

  // dynamic component RelatedContentList
  components.set('RelatedContentList', loadable(() => import(/* webpackChunkName: "RelatedContentList" */'../components/Corporate/RelatedContentList')))

  // standard component RelatedContentMap
  components.set('RelatedContentMap', RelatedContentMap);

  // dynamic component SearchResultCard
  components.set('SearchResultCard', loadable(() => import(/* webpackChunkName: "SearchResultCard" */'../components/Corporate/SearchResultCard')))

  // dynamic component SearchResults
  components.set('SearchResults', loadable(() => import(/* webpackChunkName: "SearchResults" */'../components/Corporate/SearchResults')))

  // standard component SingleColumn
  components.set('SingleColumn', SingleColumn);

  // dynamic component SingleImage
  components.set('SingleImage', loadable(() => import(/* webpackChunkName: "SingleImage" */'../components/Corporate/SingleImage')))

  // dynamic component TagList
  components.set('TagList', loadable(() => import(/* webpackChunkName: "TagList" */'../components/Corporate/TagList')))

  // standard component Timeline
  components.set('Timeline', Timeline);

  // standard component TwoColumn
  components.set('TwoColumn', TwoColumn);

  // dynamic component WhatsOnRelatedContent
  components.set('WhatsOnRelatedContent', loadable(() => import(/* webpackChunkName: "WhatsOnRelatedContent" */'../components/Corporate/WhatsOnRelatedContent')))

export default function componentFactory(componentName) {
  return components.get(componentName);
};
